import { render } from "./Greeter.vue?vue&type=template&id=5cf08c44&scoped=true"
import script from "./Greeter.vue?vue&type=script&lang=js"
export * from "./Greeter.vue?vue&type=script&lang=js"

import "./Greeter.vue?vue&type=style&index=0&id=5cf08c44&scoped=true&lang=css"

import exportComponent from "/home/carlos/dev/libre-sube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf08c44"]])

export default __exports__